<template>
  <div class="color-cell">
    <span class="swatch" :style="swatchStyle">
      {{ labelTag }}
    </span>
  </div>
</template>

<script>
export default {
  name: "operationInstructionColor",
  props: { item: { type: Object, required: true } },
  computed: {
    label() {
      const l = this.item?.operatingInstructionLabel;
      return l && typeof l === "object" ? l : null;
    },
    labelTag() {
      return this.label?.tag || "No tag";
    },
    cssColor() {
      return this.normalizeColor(this.label?.color || "");
    },
    swatchStyle() {
      return { background: this.cssColor || "transparent" };
    },
  },
  methods: {
    normalizeColor(c) {
      if (!c) return "";
      const s = String(c).trim();
      if (/^[0-9a-fA-F]{3,4}$|^[0-9a-fA-F]{6}$|^[0-9a-fA-F]{8}$/.test(s))
        return `#${s}`;
      if (/^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(s))
        return s;
      return s;
    },
  },
};
</script>

<style scoped>
.color-cell {
  display: inline-flex;
  align-items: center;
}

.swatch {
  padding: 2px 15px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
